import React from 'react';
import { Button } from './Button';
export function PurchaseSection() {
  const rows = [{
    icon: '📘',
    name: 'Guía Práctica de Comandos Eléctricos',
    value: '$97 USD'
  }, {
    icon: '🎁',
    name: 'Regalo 1: Dominio Total en PLC y Automatización',
    value: '$67 USD'
  }, {
    icon: '🎁',
    name: 'Regalo 2: Instalaciones Eléctricas Domiciliarias Pro',
    value: '$47 USD'
  }, {
    icon: '🎁',
    name: 'Regalo 3: Tablerista Eléctrico de Élite',
    value: '$37 USD'
  }, {
    icon: '🎁',
    name: 'Regalo 4: Biblioteca Maestra de Planos y Diagramas',
    value: '$37 USD'
  }, {
    icon: '🎁',
    name: 'Regalo 5: Protocolo Antifallas Revisión y Prueba',
    value: '$27 USD'
  }, {
    icon: '🎁',
    name: 'Regalo 6: Guía para Cobrar como un Profesional',
    value: '$27 USD'
  }];
  return <section id="compra" className="bg-brand-bg text-brand-text px-4 py-10 scroll-mt-4" data-id="element-115">
      <div className="max-w-xl mx-auto" data-id="element-116">
        <h2 className="text-xl md:text-2xl font-black text-center mb-6 text-yellow" data-id="element-117">
          🧰 TODO LO QUE INCLUYE TU MEGA PACK HOY
        </h2>

        <div className="bg-brand-card border border-brand-border rounded-lg overflow-hidden mb-6" data-id="element-118">
          {rows.map((r, i) => <div key={i} className="flex items-center justify-between gap-3 px-4 py-3 border-b border-brand-border" data-id="element-119">
              <span className="text-sm text-brand-text flex-1" data-id="element-120">
                <span className="mr-1.5" data-id="element-121">{r.icon}</span>
                {r.name}
              </span>
              <span className="text-sm font-bold text-brand-muted line-through shrink-0" data-id="element-122">
                {r.value}
              </span>
            </div>)}
          <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-brand-border bg-brand-surface" data-id="element-123">
            <span className="text-sm font-black text-white" data-id="element-124">
              💰 VALOR TOTAL
            </span>
            <span className="text-sm font-black text-brand-muted line-through shrink-0" data-id="element-125">
              $339 USD
            </span>
          </div>
          <div className="flex items-center justify-between gap-3 px-4 py-4 bg-brand-card" data-id="element-126">
            <span className="text-base font-black text-yellow" data-id="element-127">
              🔥 TU PRECIO HOY
            </span>
            <span className="text-2xl font-black text-yellow shrink-0" data-id="element-128">
              $17.90 USD
            </span>
          </div>
        </div>

        <Button href="https://master-electrotecnico.impultienda.ar/checkout" data-id="element-129">
          🔴 SÍ, QUIERO EL MEGA PACK — $17.90 USD
        </Button>

        <p className="text-xs text-center text-brand-muted mt-3 leading-relaxed" data-id="element-130">
          🌐 Pago Seguro y Moneda Local: Al hacer clic, verás el precio
          convertido automáticamente a tu moneda local. 🔒 Pago 100% Protegido.
        </p>
      </div>
    </section>;
}